<template>
  <div v-bind="$attrs">
    <v-search
      :value="value"
      :items="res"
      item-text="full_name"
      item-value="id"
      :loading="loading"
      :required="required"
      :hint="hint"
      :search-input.sync="searchStr"
      :disabled="disabled"
      placeholder="Search contacts"
      @search="search"
      @input="$emit('input', $event)"
      @select="select"
      @clear="clearResults"
      @valid-update="updateValidState"
    />
  </div>
</template>

<script>
import VSearch from '@/components/base/VSearch'

export default {
  props: {
    value: {
      type: [Number, String, Object],
    },
    accountId: {
      type: [Number, String]
    },
    selected: {
      type: Object
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    }
  },
  components: { VSearch },
  data() {
    return {
      loading: false,
      res: [],
      searchStr: '',
      isValid: false
    }
  },
  computed: {
    hint({ loading, searchStr }) {
      if (loading) {
        return 'loading'
      } else if (searchStr == null || searchStr == '') {
        return 'Please enter your search terms'
      } else {
        return 'No contacts found'
      }
    }
  },
  created() {
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      if (this.value) {
        this.$http.contacts.get(this.value).then(resp => {
          this.searchStr = resp.data.full_name;
        });
      }
    },
    search(v) {
      if(v) {
        this.loading = true;
        let params = {}
        if (this.accountId) {
          params['account_id'] = this.accountId;
        }
        params.full_name = v;
        this.$http.contacts.get(params).then(resp => {
          this.res = resp.data.results;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    select(v) {
      this.$emit('update:selected', v);
    },
    clearResults() {
      this.res = [];
    },
    updateValidState(v) {
      this.isValid = v;
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown.is-fullwidth {
  width: 100% !important;
  .dropdown-trigger {
    width: 100%;
  }
}

.is-clickable {
  cursor: pointer;
  pointer-events: initial !important;
}
</style>
